import { render } from "./Simple.vue?vue&type=template&id=60025b54"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/PageHeader/Simple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60025b54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60025b54', __exports__)) {
    api.reload('60025b54', __exports__)
  }
  
  module.hot.accept("./Simple.vue?vue&type=template&id=60025b54", () => {
    api.rerender('60025b54', render)
  })

}


export default __exports__